import React, { ReactElement, useContext, useEffect, createContext, useState, SetStateAction, Dispatch } from "react"
import styles from "../styles/ErrorBoundary.module.css"
import * as Sentry from "@sentry/react"

const RetryContext = createContext<{
  maxTries: number
  useTries: [number, Dispatch<SetStateAction<number>>]
}>({
  maxTries: 3,
  useTries: [0, () => {}],
})

const Retry = ({ resetError }: { resetError: () => void }) => {
  const {
    useTries: [tries, setTries],
    maxTries,
  } = useContext(RetryContext)

  useEffect(() => {
    if (tries < maxTries) {
      console.warn(`ErrorBoundary Retrying ${tries + 1}/${maxTries}`)
      resetError()
      setTries(tries + 1)
    }
  }, [tries, maxTries, resetError])
  return null
}

const Reload = (({ error, resetError }) => {
  return (
    <>
      <Retry resetError={resetError} />
      <div className={styles.container}>
        <div className={styles.button} onClick={resetError}>
          다시 불러오기
        </div>
        <aside style={{ display: "none" }}>
          <h1>{error.name}</h1>
          <p>{error.message}</p>
        </aside>
      </div>
    </>
  )
}) as Sentry.FallbackRender

export const ErrorBoundary: React.FC<{ maxTries?: number; children: ReactElement }> = ({ maxTries = 3, children }) => {
  const useTries = useState(0)
  return (
    <RetryContext.Provider
      value={{
        maxTries,
        useTries: useTries,
      }}>
      <Sentry.ErrorBoundary fallback={Reload}>{children}</Sentry.ErrorBoundary>
    </RetryContext.Provider>
  )
}
